var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyStar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none",
    viewBox: "0 0 44 44",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EAECEE",
    d: "M22.0022 4.3999c.6324 0 1.2099.3575 1.4848.928l4.7159 9.7137 10.5317 1.5536a1.639 1.639 0 0 1 1.3268 1.1206 1.657 1.657 0 0 1-.4056 1.6842l-7.6375 7.5757 1.8011 10.6967a1.662 1.662 0 0 1-.66 1.6155c-.5087.3712-1.1892.4125-1.7392.1169l-9.418-5.0322-9.4112 5.0253c-.5568.2956-1.2305.2543-1.7393-.1169-.5087-.3712-.7699-.9968-.6668-1.6155l1.8011-10.6967L4.3485 19.4c-.4468-.4399-.598-1.093-.4056-1.6842.1925-.5912.708-1.0243 1.3268-1.1206l10.5317-1.5536 4.7159-9.7136c.2818-.5706.8524-.9281 1.4849-.9281m0 5.4308-3.6091 7.4382c-.2407.4881-.7012.8318-1.2443.9143l-8.1325 1.1962 5.9051 5.8502c.3781.3781.5569.9143.4675 1.4436l-1.3955 8.2288 7.2319-3.8635c.4881-.2612 1.0725-.2612 1.5537 0l7.2319 3.8635-1.3886-8.2219a1.635 1.635 0 0 1 .4674-1.4436l5.9052-5.8502-8.1325-1.2031c-.5362-.0825-1.0037-.4193-1.2443-.9143z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/empty-star.e46012151ae288d0142bf1139aaa490a.svg";